
function initThemeCustomJS() {
  
  // jQuery.documentSize, v1.2.4
  // Copyright (c) 2015-2017 Michael Heim, Zeilenwechsel.de
  // Distributed under MIT license
  // http://github.com/hashchange/jquery.documentsize
  !function(e){"use strict";function t(e,t){var n,r,i,u,c,a=t.window,w=0!==l(),p=t.useLayoutViewport&&"Width"===e,s=w||!d()||p,v=s?a.document.documentElement["client"+e]:m(e,a);return t.useLayoutViewport&&!s&&(r=v,i=o(a,{asRange:!0}),v=Math.round(r*i.calculated),f()||(n=a.document.documentElement.clientHeight,u=(r-1)*i.min,c=(r+1)*i.max,(v<=n+3&&v>=n-3||u<=n&&c>=n&&c<n+30)&&(v=n))),v}function o(e,t){var o,n,r=t&&t.asRange,i={calculated:1,min:1,max:1};return 0!==l()||!d()||(e||(e=window),o=e.document.documentElement.clientWidth,n=a(e),i.calculated=o/n,r&&(f()?i.min=i.max=i.calculated:(i.min=o/(n+1),i.max=o/(n-1)))),r?i:i.calculated}function n(e){var t,o,n,d=window,l=!0;return e&&e.length&&((t=w((e=Array.prototype.slice.call(e))[0]))||(e[0]=i(e[0])),(o=!t&&e[0])||(e[1]=i(e[1])),n=!o&&e[1],t?(d=e[0],n&&e[1].viewport&&(l=r(e[1].viewport))):o?(e[0].viewport&&(l=r(e[0].viewport)),w(e[1])&&(d=e[1])):!e[0]&&e[1]&&(n&&e[1].viewport?l=r(e[1].viewport):w(e[1])&&(d=e[1]))),{window:d,useVisualViewport:l,useLayoutViewport:!l}}function r(e){var t=p(e)&&e.toLowerCase();if(e&&!t)throw new Error("Invalid viewport option: "+e);if(t&&"visual"!==t&&"layout"!==t)throw new Error("Invalid viewport name: "+e);return"visual"===t}function i(e){return p(e)&&""!==e?{viewport:e}:e}function d(){return void 0===y&&(y=a()>10),y}function l(){var e;return void 0===v&&((e=document.createElement("div")).style.cssText="width: 100px; height: 100px; overflow: scroll; position: absolute; top: -500px; left: -500px; margin: 0px; padding: 0px; border: none;",document.body.appendChild(e),v=e.offsetWidth-e.clientWidth,document.body.removeChild(e)),v}function u(){var e,t,o,n,r=function(){var e=document.createElement("iframe"),t=document.body;if(e.style.cssText="position: absolute; top: -600px; left: -600px; width: 500px; height: 500px; margin: 0px; padding: 0px; border: none; display: block;",e.frameborder="0",t.appendChild(e),e.src="about:blank",!e.contentDocument)return;return e.contentDocument.write('<!DOCTYPE html><html><head><meta charset="UTF-8"><title></title><style type="text/css">html, body { overflow: hidden; }</style></head><body></body></html>'),e}(),i=r&&r.contentDocument||document,d=i.body,l=i!==document;(t=i.createElement("div")).style.cssText="width: 1px; height: 1px; position: relative; top: 0px; left: 32000px;",l||(e=function(){var e,t,o=document.documentElement,n=document.body,r=x?window.getComputedStyle(o,null):o.currentStyle,i=x?window.getComputedStyle(n,null):n.currentStyle,d=(r.overflowX||r.overflow||"visible").toLowerCase(),l="hidden"!==(i.overflowX||i.overflow||"visible").toLowerCase(),u="visible"===d,c={documentElement:{modified:u},body:{modified:l}};u&&(e=o.style,c.documentElement.styleOverflowX=e.overflowX,e.overflowX="auto");l&&(t=n.style,c.body.styleOverflowX=t.overflowX,t.overflowX="hidden");return c}()),o=d.scrollWidth,d.appendChild(t),n=o!==d.scrollWidth,d.removeChild(t),l||function(e){e.documentElement.modified&&(document.documentElement.style.overflowX=e.documentElement.styleOverflowX);e.body.modified&&(document.body.style.overflowX=e.body.styleOverflowX)}(e),b=n?"documentElement":"body",r&&document.body.removeChild(r)}function c(e,t){var o=t.documentElement;return Math.max(o.body["scroll"+e],t["scroll"+e],o.body["offset"+e],t["offset"+e],t["client"+e])}function a(e){return m("Width",e)}function m(e,t){var o=(t||window).visualViewport?(t||window).visualViewport[e.toLowerCase()]:(t||window)["inner"+e];return o&&function(e){!h&&function(e){return e===+e&&e!==(0|e)}(e)&&(h=!0)}(o),o}function f(){return!!h}function w(e){return null!=e&&e.window==e}function p(e){return"string"==typeof e||e&&"object"==typeof e&&"[object String]"===Object.prototype.toString.call(e)||!1}function s(){var e;return void 0===g&&(g=!1,e=navigator&&navigator.userAgent,navigator&&"Microsoft Internet Explorer"===navigator.appName&&e&&null!=new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})").exec(e)&&(g=parseFloat(RegExp.$1))),g}var v,y,h,b,g,x=!!window.getComputedStyle;if(e.documentWidth=function(e){var t;e||(e=document);try{void 0===b&&u(),t=e[b].scrollWidth}catch(o){t=c("Width",e)}return t},e.documentHeight=function(e){var t;e||(e=document);try{void 0===b&&u(),t=e[b].scrollHeight}catch(o){t=c("Height",e)}return t},e.windowWidth=function(e,o){return t("Width",n(arguments))},e.windowHeight=function(e,o){return t("Height",n(arguments))},e.pinchZoomFactor=function(e){return o(e)},e.scrollbarWidth=l,"function"==typeof e&&!function(){var e=s();return e&&e<8}()&&9!==s())try{e(function(){void 0===b&&u(),l()})}catch(e){}}("undefined"!=typeof jQuery?jQuery:"undefined"!=typeof Zepto?Zepto:$);
  
  function getWindowSize() { // ---> rely on libs/documentsize.js
	
    var size = {
      width: $.windowWidth("layout"),
      height: $.windowHeight("layout")
    };

    return size;
  };
  
  function getThemeHeaderHeight() {
  
    var headerHeight = $('#shopify-section-header').outerHeight();

    return headerHeight;
  }

  function resizeThemeMainContent() {
  
    var windowWidth = getWindowSize().width;
    var windowHeight = getWindowSize().height;
    
    var viewportHeight = windowHeight - getThemeHeaderHeight() - parseInt($('.main-content').css('margin-top'));

    $('.main-content').css({minHeight:viewportHeight});
  }
  
  //---> BIND HANDLERS
  
  $(window).on('resize', function() {
    resizeThemeMainContent();
  });
  
  //---> REFACTOR CART LINK ON DESKTOP
  
  $('.header-bar__cart-count').appendTo('.header-bar__module:nth-child(2) .cart-page-link');
  $('.header-bar__module:nth-child(3)').remove();
  
  //---> ADD SEARCH LINK ON DESKTOP
  
  //$('<span class="header-bar__sep" aria-hidden="true"></span><a href="/search" class="search-page-link"><span class="icon icon-search header-bar__search-icon" aria-hidden="true"></span></a>').prependTo('.header-bar__module:last-child');
  
  //---> ADD SEARCH LINK ON MOBILE
  
  //$('<a href="/search" class="search-page-link mobile-search-page-link"><span class="icon icon-search header-bar__search-icon" aria-hidden="true"></span></a>').insertAfter('.header-bar .mobile-cart-page-link');
  
  //---> ADD TOP & BOTTOM SPACE TO MOBILE NAV
  
  $('<li></li>').prependTo('.header-bar nav > .mobile-nav');
  $('<li></li>').appendTo('.header-bar nav > .mobile-nav');
  
  //---> CONSOLIDATE LAYOUT
  
  resizeThemeMainContent();

  // Set cookie settings call for footer menu item

  $('#shopify-section-footer .site-footer__links a[href*="#cookie-settings"]').click(function(e) {
    showPreferences();
    e.preventDefault();
  });
  
  //---> ADD CSS INIT HELPER CLASS
  
  $('html').addClass('theme-inited');
  
  //---> ADD PAGE BACKTOP FOR GALLERY THUMBNAILS ON PRODUCT DETAIL
  
  $('#shopify-section-product-template .product-single__thumbnails a.product-single__thumbnail').on('click', function() {
    $('html, body').animate({scrollTop:0}, 250);
  });

  //---> PRODUCTS PAGE - "Browse by" SELECT OPTIONS LOCALIZATION FIX

  if ($('body').hasClass('template-collection')) {
    $('#BrowseBy option').each(function() {
      
      var label = $(this).html();
      //console.log(label);

      if (label == "ceiling") {
        if (Shopify.locale == "it") {
          $(this).html('soffitto');
        }
        if (Shopify.locale == "fr") {
          $(this).html('plafonnier');
        }
        if (Shopify.locale == "de") {
          $(this).html('Deckenleuchten');
        }
      }

      if (label == "chandelier (all)") {
        if (Shopify.locale == "it") {
          $(this).html('sospensioni');
        }
        if (Shopify.locale == "fr") {
          $(this).html('lustre (tout)');
        }
        if (Shopify.locale == "de") {
          $(this).html('Hängeleuchten');
        }
      }

      if (label == "chandelier (vertical)") {
        if (Shopify.locale == "it") {
          $(this).html('sospensioni verticali');
        }
        if (Shopify.locale == "fr") {
          $(this).html('lustre vertical');
        }
        if (Shopify.locale == "de") {
          $(this).html('vertikale Hängeleuchten');
        }
      }

      if (label == "linear chandelier &amp; pendant") {
        if (Shopify.locale == "it") {
          $(this).html('sospensioni lineari');
        }
        if (Shopify.locale == "fr") {
          $(this).html('lustre linéaire');
        }
        if (Shopify.locale == "de") {
          $(this).html('lineare Hängeleuchten');
        }
      }

      if (label == "pendant (all)") {
        if (Shopify.locale == "it") {
          $(this).html('pendenti');
        }
        if (Shopify.locale == "fr") {
          $(this).html('suspension (tout)');
        }
        if (Shopify.locale == "de") {
          $(this).html('Pendelleuchten');
        }
      }

      if (label == "pendant (cluster)") {
        if (Shopify.locale == "it") {
          $(this).html('pendenti multipli');
        }
        if (Shopify.locale == "fr") {
          $(this).html('suspension multi-lumières');
        }
        if (Shopify.locale == "de") {
          $(this).html('mehrflammige Pendelleuchten');
        }
      }

      if (label == "pendant (glass)") {
        if (Shopify.locale == "it") {
          $(this).html('pendenti in vetro');
        }
        if (Shopify.locale == "fr") {
          $(this).html('suspension en verre');
        }
        if (Shopify.locale == "de") {
          $(this).html('Pendelleuchten aus Kristall');
        }
      }

      if (label == "pendant (small)") {
        if (Shopify.locale == "it") {
          $(this).html('pendenti piccoli');
        }
        if (Shopify.locale == "fr") {
          $(this).html('petite suspension');
        }
        if (Shopify.locale == "de") {
          $(this).html('kleine Pendelleuchten');
        }
      }

      if (label == "rechargeable table") {
        if (Shopify.locale == "it") {
          $(this).html('da tavolo ricaricabile');
        }
        if (Shopify.locale == "fr") {
          $(this).html('lampe de table rechargeable');
        }
        if (Shopify.locale == "de") {
          $(this).html('Akku Tischleuchten');
        }
      }

      if (label == "suspended sculpture") {
        if (Shopify.locale == "it") {
          $(this).html('sculture sospese');
        }
        if (Shopify.locale == "fr") {
          $(this).html('sculpture suspendue');
        }
        if (Shopify.locale == "de") {
          $(this).html('hängende Skulpturen');
        }
      }

      if (label == "table and floor") {
        if (Shopify.locale == "it") {
          $(this).html('da tavolo e da terra');
        }
        if (Shopify.locale == "fr") {
          $(this).html('lampe de table et lampadaire');
        }
        if (Shopify.locale == "de") {
          $(this).html('Tischleuchten und Stehleuchten');
        }
      }

      if (label == "wall sconce") {
        if (Shopify.locale == "it") {
          $(this).html('da parete');
        }
        if (Shopify.locale == "fr") {
          $(this).html('applique murale');
        }
        if (Shopify.locale == "de") {
          $(this).html('Wandleuchten');
        }
      }
    });
  }
  
  //---> CUSTOM SELECTS
  
  $('#BrowseBy, .single-option-selector').selectric({
    maxHeight: '',
    arrowButtonMarkup: '',
    disableOnMobile: false,
    nativeOnMobile: false,
    optionsItemBuilder: Modernizr.touch ? '<a href="#">{text}</a>' : '{text}',
    labelBuilder: Modernizr.touch ? '<a href="#">{text}</a>' : '{text}',
    preventWindowScroll: false
  });
  
  $('.selectric-wrapper').closest('.form-horizontal').find('label').click(function(e) { e.preventDefault(); });
  
  $('.selector-wrapper label').click(function(e) { e.preventDefault(); });

  //---> SEARCH RESULT PAGE - REMOVE "," CHAR IN PRICE FILTER

  if ($('body').hasClass('snize-results-page')) {
    var waitForPriceFilter = setInterval(function() {
      var el = $('#snize_filters_dropdown_price .snize-product-filters-price-symbol');
      if (el.length) {
        //clearInterval(waitForPriceFilter);
        
        var label = el.html();
        el.html(label.replace(',', ''));
      }
	}, 100);
  }

  //---> INVENTORA - SHOW STOCK LEVEL LOCALIZATION FIX

  if ($('body').hasClass('template-product')) {
    var waitForGSInventory = setInterval(function() {
      if ($('.product-single .gsinventory').length) {
        //clearInterval(waitForGSInventory);
        $('.product-single .gsinventory').each(function() {
          
          var label = $(this).html();
          //console.log(label);

          if (label == "estimated 12 weeks lead time") {
            if (Shopify.locale == "it") {
              $(this).html('spedizione stimata entro 12 settimane');
            }
            if (Shopify.locale == "fr") {
              $(this).html('délai de livraison estimé de 12 semaines');
            }
            if (Shopify.locale == "de") {
              $(this).html('Voraussichtliche Lieferzeit innerhalb von 12 Wochen');
            }
          }

          if (label == "estimated 1 week lead time") {
            if (Shopify.locale == "it") {
              $(this).html('spedizione stimata entro 1 settimana');
            }
            if (Shopify.locale == "fr") {
              $(this).html('délai de livraison estimé de 1 semaine');
            }
            if (Shopify.locale == "de") {
              $(this).html('Voraussichtliche Lieferzeit innerhalb von 1 Woche');
            }
          }

          if (label == "estimated 14 weeks lead time") {
            if (Shopify.locale == "it") {
              $(this).html('spedizione stimata entro 14 settimane');
            }
            if (Shopify.locale == "fr") {
              $(this).html('délai de livraison estimé de 14 semaines');
            }
            if (Shopify.locale == "de") {
              $(this).html('Voraussichtliche Lieferzeit innerhalb von 14 Wochen');
            }
          }

          if (label == "estimated 7 to 8 weeks lead time") {
            if (Shopify.locale == "it") {
              $(this).html('spedizione stimata entro 7/8 settimane');
            }
            if (Shopify.locale == "fr") {
              $(this).html('délai de livraison estimé de 7 à 8 semaines');
            }
            if (Shopify.locale == "de") {
              $(this).html('Voraussichtliche Lieferzeit innerhalb von 7/8 Wochen');
            }
          }

          if (label == "estimated 7 to 10 weeks lead time") {
            if (Shopify.locale == "it") {
              $(this).html('spedizione stimata entro 7/10 settimane');
            }
            if (Shopify.locale == "fr") {
              $(this).html('délai de livraison estimé de 7 à 10 semaines');
            }
            if (Shopify.locale == "de") {
              $(this).html('Voraussichtliche Lieferzeit innerhalb von 7/10 Wochen');
            }
          }

          if (label == "estimated 6 to 8 weeks lead time") {
            if (Shopify.locale == "it") {
              $(this).html('spedizione stimata entro 6/8 settimane');
            }
            if (Shopify.locale == "fr") {
              $(this).html('délai de livraison estimé de 6 à 8 semaines');
            }
            if (Shopify.locale == "de") {
              $(this).html('Voraussichtliche Lieferzeit innerhalb von 6/8 Wochen');
            }
          }

          if (label == "estimated 10 weeks for nickel and 14 weeks for other finishes lead time") {
            if (Shopify.locale == "it") {
              $(this).html('spedizione stimata entro 10 settimane per finitura nichel e entro 14 settimane per altre finiture');
            }
            if (Shopify.locale == "fr") {
              $(this).html('délai de livraison estimé de 10 semaines pour le finition nickel et de 14 semaines pour les autres finitions');
            }
            if (Shopify.locale == "de") {
              $(this).html('Voraussichtliche Lieferzeit innerhalb von 10 Wochen für Nickel und innerhalb von 14 Wochen für andere Farben');
            }
          }

          if (label == "estimated 9 to 10 weeks lead time") {
            if (Shopify.locale == "it") {
              $(this).html('spedizione stimata entro 9/10 settimane');
            }
            if (Shopify.locale == "fr") {
              $(this).html('délai de livraison estimé de 9 à 10 semaines');
            }
            if (Shopify.locale == "de") {
              $(this).html('Voraussichtliche Lieferzeit innerhalb von 9/10 Wochen');
            }
          }

          if (label == "estimated 3 weeks lead time on stainless steel and 7 to 8 weeks lead time on other finishes") {
            if (Shopify.locale == "it") {
              $(this).html('spedizione stimata entro 3 settimane per la versione acciaio inossidabile, 7/8 settimane per le altre versioni');
            }
            if (Shopify.locale == "fr") {
              $(this).html('délai de livraison estimé de 3 semaines pour la version en acier inoxydable, 7 à 8 semaines pour les autres versions');
            }
            if (Shopify.locale == "de") {
              $(this).html('Voraussichtliche Lieferzeit innerhalb von 3 Wochen für die Edelstahl-Version, innerhalb von 7/8 Wochen für die anderen Versionen');
            }
          }

          if (label.includes("for more")) {
            if (Shopify.locale == "it") {
              $(this).html(label.replace("for more", "per quantità superiori"));
            }
            if (Shopify.locale == "fr") {
              $(this).html(label.replace("for more", "pour des quantités supérieures"));
            }
            if (Shopify.locale == "de") {
              $(this).html(label.replace("for more", "für größere Mengen"));
            }
          }
          
          if (label == "made to order") {
            if (Shopify.locale == "it") {
              $(this).html('non in stock');
            }
            if (Shopify.locale == "fr") {
              $(this).html('sur commande');
            }
            if (Shopify.locale == "de") {
              $(this).html('Nicht auf Lager');
            }
          }
        });
      }
	}, 100);
  }

  //---> TABS STUDIO APP - PROTAB "support" LABEL LOCALIZATION FIX

  if ($('body').hasClass('template-product')) {
    var waitForProTab = setInterval(function() {
      if ($('.product-single .station-tabs.is-ready').length) {
        clearInterval(waitForProTab);
        
        if (Shopify.locale == "it") {
          $('a[id^="st-link-support"]').html('supporto');
        }
        if (Shopify.locale == "fr") {
          $('a[id^="st-link-support"]').html('service client');
        }
        if (Shopify.locale == "de") {
          $('a[id^="st-link-support"]').html('Kundendienst');
        }
      }
	}, 100);
  }
}